import { render, staticRenderFns } from "./TopJettonItem.vue?vue&type=template&id=dcb3c322"
import script from "./TopJettonItem.vue?vue&type=script&lang=js"
export * from "./TopJettonItem.vue?vue&type=script&lang=js"
import style0 from "./TopJettonItem.vue?vue&type=style&index=0&id=dcb3c322&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports